import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react"
import { Provider } from "react-redux";
import { store } from "./Redux/store";
import { AuthProvider } from "./context/AuthContext";

import ReactGA from "react-ga4";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { MeasurementId } from "./Utils/constants";

// Google Analytics Initialize
ReactGA.initialize(MeasurementId); // Apni GA4 Measurement ID yahan dalen

// Track Page View
ReactGA.send("pageview");


// Function to Track User Sessions
const trackUserSession = () => {
  const userId = localStorage.getItem("userId") || `guest_${Date.now()}`;
  localStorage.setItem("userId", userId);

  ReactGA.set({ userId }); // Google Analytics me user ID set karein
  ReactGA.event({
    category: "User",
    action: "Session Start",
    label: `User ${userId}`
  });
};

trackUserSession(); // Jab bhi user aaye track karein


const root = ReactDOM.createRoot(document.getElementById("root"));




const theme = createTheme(); // Use the default theme
root.render(
  <AuthProvider>
    <BrowserRouter>
      <Provider store={store}>
        <ChakraProvider>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>,
        </ChakraProvider>
      </Provider>
    </BrowserRouter >
  </AuthProvider>
);
